import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'reactstrap'

import { initializeApp } from '../../ducks/app'

import Preloader from '../../components/UI/Preloader'

export default (BaseComponent) => {
  class ReactHOC extends Component {
    componentDidMount() {
      const { initializeApp, app } = this.props
      const { initialized, loading } = app

      if (!initialized || !loading) {
        initializeApp()
      }
    }

    render() {
      const { initialized, loading } = this.props.app

      if (loading || !initialized) {
        return (
          <Row>
            <Col xs={12}>
              <Preloader />
            </Col>
          </Row>
        )
      }

      return <BaseComponent {...this.props} />
    }
  }

  ReactHOC.displayName = 'WithInitialization'

  return connect(
    ({ app }) => ({
      app
    }),
    { initializeApp }
  )(ReactHOC)
}
